export const PROXIMA_NOVA = 'Proxima Nova';
export const TIMES_NEW_ROMAN_ITALIC = 'TimesNewRomanPS-ItalicMT';
export const TIMES_NEW_ROMAN = 'TimesNewRomanPSMT';



// WEBPACK FOOTER //
// ./src/fonts.js